import { wsCall, requestHelper, setSuccess } from "../../../app/coreSlice";
import { assetAssetReservationCounts, assetList } from "../../asset/assetSlice";

const reservationRequestReservationExtensionCall = async (
  { setSelectedTrip },
  dispatch,
  state,
  { reservationCode },
  oldActions
) => {
  const selectedLocation = state?.getIn(["carclub2"])?.defaultLocation;
  const selectedTrip = state?.getIn(["reservations"])?.selectedTrip;
  let rh = requestHelper(dispatch, "RESERVATION/REQUEST_RESERVATION_EXTENSION");
  try {
    const result = await wsCall({
      type: "RESERVATION",
      subType: "REQUEST_RESERVATION_EXTENSION",
      locationId: selectedLocation?.id,
      message: {
        reservationCode,
      },
    });

    if (!result.error) {
      dispatch(setSuccess("Reservation extended successfully!"));
      let nReservation = { ...selectedTrip, ...(result || {}) };
      dispatch(setSelectedTrip(nReservation));
      oldActions.update(result);
      setTimeout(() => {
        // this should be update using notifications
        dispatch(assetList({}));
        dispatch(assetAssetReservationCounts());
      }, 300);
      // refresh reservations
    } else {
      rh.error(result?.description || "Error extending reservation.");
    }
  } catch (_ex) {
    rh.error("Error extending reservation.");
  }
  rh.close();
};

export default reservationRequestReservationExtensionCall;
